<template>
  <div class="absolute-fit-container" :style="{ zIndex }">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  zIndex: {
    type: Number,
    default: 1,
  },
});
</script>

<style lang="scss" scoped>
.absolute-fit-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
